import { Tooltip as AntdTooltip } from "antd"
import theme from "utils/themeVars"

const Tooltip = props => {
  return <AntdTooltip overlayInnerStyle={{ color: theme["base-color"] }} color={"white"}  {...props}></AntdTooltip>
}

export default Tooltip
